import Vue from 'vue'
import App from './App'
import {routers, appRouter} from './router'
import iView from 'iview';
import VueRouter from 'vue-router';
import 'iview/dist/styles/iview.css';
import Util from './util';

require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('font-awesome/css/font-awesome.css')
require('froala-editor/css/froala_style.min.css')
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)

Vue.use(iView);
Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
    routes: routers
};

const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    Util.title(to.meta.title);
    // Util.toDefaultPage([ ...appRouter], to.name, router, next);
    next()
    iView.LoadingBar.finish();
});

router.afterEach(() => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

new Vue({
  	el: '#app',
    router: router,
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js